import { reportError } from "./error-reporting"

// Global error handler setup
export const setupGlobalErrorHandler = () => {
  // Handle unhandled promise rejections
  if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled promise rejection:', event.reason)
      
      const error = new Error(
        event.reason?.message || 'Unhandled promise rejection'
      )
      error.name = 'UnhandledPromiseRejection'
      error.stack = event.reason?.stack || error.stack
      
      reportError(error, {
        type: 'unhandledrejection',
        promise: event.promise,
        reason: event.reason,
      })
    })

    // Handle general JavaScript errors
    window.addEventListener('error', (event) => {
      console.error('Global error:', event.error)
      
      const error = event.error || new Error(event.message || 'Unknown error')
      
      reportError(error, {
        type: 'error',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      })
    })
  }
}